export default {
  createSingleComparatorFilter(value, comparator, field, isDate = false) {
    return [field, comparator, value];
  },
  getHistoryFieldFromField(field) {
    if (typeof field !== 'string') {
      return field;
    }
    if (field.startsWith('data/')) {
      return field.substring(5);
    }
    return field;
  }
};